import React from 'react';
import './SuccessMessage.css';

interface SuccessMessageProps {
  firstName: string;
  surname: string;
  year: number | null;
  onReset: () => void;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({ firstName, surname, year, onReset }) => {
  return (
    <div className="success-message">
      <div className="success-icon">✓</div>
      <h2 className="success-title">Anmeldung erfolgreich!</h2>
      <p className="success-text">
        Willkommen, <strong>{firstName} {surname}</strong>!
      </p>
      <p className="success-subtext">
        Sie wurden als Helfer für Römerman {year ?? '–'} registriert.
      </p>
      <button onClick={onReset} className="reset-button">
        Weiteren Helfer registrieren
      </button>
    </div>
  );
};

export default SuccessMessage;

